import data from "./config.json";

const val = data[window.location.host];

export default val;
